<template lang="pug">
.fixed.inset-0
  transition(name="slide-down-toggle")
    .absolute.inset-0(v-if="mode=='status'")
      status(@share="share")   
  transition(name="slide-up-toggle")
    .absolute.inset-0(v-if="mode=='share'")
      share(@status="status")
</template>

<script>
import Status from "@/components/status/status";
import Share from "@/components/status/share";
export default {
  components: {
    Status,
    Share
  },
  data() {
    return {
      mode: "status"
    };
  },
  methods: {
    status() {
      this.mode = "status";
    },
    share() {
      this.mode = "share";
    }
  }
};
</script>
